import type { PopupData } from 'webapp-types';

import MetricLibraryPopupsMetricComponent from 'webapp/components/metric-library/popups/metric';
import PopupInnerContextComponent from 'webapp/components/popup/inner/context';

export default class MetricLibraryPopupsPopupMetric extends PopupInnerContextComponent<PopupData.MetricLibrary.MetricInfo> {
	<template><MetricLibraryPopupsMetricComponent @popupModel={{@model}} /></template>
}
